import { Image } from 'react-bootstrap';
import { CellProps, Column } from 'react-table';
import OctTooltip from 'src/app/modules/component/tooltip';
import { toAbsoluteUrl } from 'src/_metronic/helpers';
import { formatMoney } from '../../../utils/FormatUtils';

const formatCellNumber = (value: string) => {
	return value ? formatMoney(Number(value)) : '';
};

export const COLUMNS: Column<any>[] = [
	{
		Header: 'Mã Thuốc',
		accessor: 'code',
		width: 150,
	},
	{
		Header: 'Tên Thuốc',
		accessor: 'name',
		width: 400,
		Cell: ({ value, row: { original } }: CellProps<any>) => {
			return (
				<div className="text-truncate d-flex align-items-center">
					<OctTooltip
						placement="left-start"
						title={
							<Image
								thumbnail
								src={
									original?.medicinePicture ??
									toAbsoluteUrl('/media/images/image-placeholder.png')
								}
								style={{
									width: '150px',
								}}
							/>
						}
					>
						<Image
							alt="drug-thumbnail"
							thumbnail
							src={
								original?.medicinePicture ??
								toAbsoluteUrl('/media/images/image-placeholder.png')
							}
							style={{
								width: 'auto',
								height: 24,
								maxWidth: 24,
								marginRight: 8,
								borderRadius: 4,
								padding: 0,
								border: 'none',
							}}
						/>
					</OctTooltip>
					<span>{value}</span>
				</div>
			);
		},
	},
	{
		Header: 'Hàm Lượng',
		accessor: 'dosage',
		width: 150,
	},
	{
		Header: 'Hoạt Chất',
		accessor: 'actIngName',
		width: 150,
	},
	{
		Header: 'Đơn vị',
		accessor: 'unitofMeasureName',
		width: 120,
		Cell: ({ value }: CellProps<any>) => {
			return <div className="text-center">{value}</div>;
		},
	},
	{
		Header: 'Khả dụng',
		accessor: 'iventory',
		width: 100,
		Cell: ({ value }: CellProps<any>) => {
			return <div className="text-end">{formatCellNumber(value)}</div>;
		},
	},
	{
		Header: 'Số lô',
		accessor: 'consignment',
		width: 80,
	},
	{
		Header: 'Giá BHYT',
		accessor: 'bhytPrice',
		width: 100,
		Cell: ({ value }: CellProps<any>) => {
			return <div className="text-end">{formatCellNumber(value)}</div>;
		},
	},
	{
		Header: 'Giá VP',
		accessor: 'hospitalPrice',
		width: 100,
		Cell: ({ value }: CellProps<any>) => {
			return <div className="text-end">{formatCellNumber(value)}</div>;
		},
	},
	{
		Header: 'Giá dịch vụ',
		accessor: 'servicePrice',
		width: 100,
		Cell: ({ value }: CellProps<any>) => {
			return <div className="text-end">{formatCellNumber(value)}</div>;
		},
	},
	{
		Header: 'Giá bán',
		accessor: 'salePrice',
		width: 100,
		Cell: ({ value }: CellProps<any>) => {
			return <div className="text-end">{formatCellNumber(value)}</div>;
		},
	},
	{
		Header: 'Loại Thuốc',
		accessor: 'materialTypeName',
		width: 200,
	},
];
